import React from "react"
import {createRoot} from "react-dom/client"
import {Provider} from "react-redux"
import {PersistGate} from "redux-persist/lib/integration/react"
import packageJson from "../package.json"
import axios from "axios"
import {loadConfig} from "./config/runtime-config"
import {ThemeProvider} from "@mui/material"
import {muiTheme} from "./config/muiTheme"
// first: the stylesheets imported by the components (ui kit) must come after Bootstrap
import "bootstrap/dist/css/bootstrap.css"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import "./styles/app.scss"
import "react-toastify/dist/ReactToastify.css"

const caching = () => {
    const version = localStorage.getItem("version")
    if (version !== packageJson.version) {
        if ("caches" in window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name))
            })
            window.location.reload(true)
        }
        localStorage.setItem("version", packageJson.version)
    }
}

loadConfig()
    .then(async config => {
        axios.defaults.baseURL = config.apiHost

        await import("./config/api-config")
        await import("./config/fontawesome-library.js")

        const {persistor, store} = await import("./config/redux-persist")
        const {default: AppRouter} = await import("./components/AppRouter")

        caching()

        createRoot(document.getElementById("App")).render(
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <ThemeProvider theme={muiTheme}>
                        <AppRouter />
                    </ThemeProvider>
                </PersistGate>
            </Provider>
        )
    })
    .catch(err => {
        console.error(err)
        document.getElementById("App").innerHTML =
            '<p style="padding:2rem;font-family:sans-serif">Configuration introuvable.</p>'
    })
